<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="content min-vh-100 flex-column d-flex justify-content-between">
					<section>
						<h2 class="title">
							<img src="/img/ico-mins-travel-assistance.svg" />{{ title }}
						</h2>
						<p>
							<b>{{ intro }}</b>
						</p>
						<div class="accordion" role="tablist">
							<b-card v-for="(coverage, coverage_key) in coverages" :key="coverage_key" no-body class="mb-1">
								<div class="card-header">
									<h6>
										<button v-b-toggle="'coverage-'+coverage_key" class="btn btn-link collapsed" type="button">
											{{ coverage.title }}
										</button>
									</h6>
								</div>
								<b-collapse :id="'coverage-'+coverage_key" accordion="my-accordion" role="tabpanel">
									<b-card-body v-for="(chapter, chapter_key) in coverage.chapters" :key="chapter_key">
										<b-card-title>{{ chapter.title }}</b-card-title>
										<b-card-text v-html="chapter.text"></b-card-text>
										<b-card-sub-title>LIMIT</b-card-sub-title>
										<b-card-text v-html="chapter.limit || '-'"></b-card-text>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</section>
					<ReadAllTermsAndConditions/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReadAllTermsAndConditions from '@/components/ReadAllTermsAndConditions.vue'

export default {
	components: {
		ReadAllTermsAndConditions,
	},
	data(){
		return {
			title: "TRAVEL ASSISTANCE",
			intro: "In the event of illness or an injury during a Business or Leisure Trip, the Company, through its Operations Centre available 24/7, shall organise and provide the following services:",
			coverages: [
				{
					title: "MEDICAL CONSULTATION BY TELEPHONE",
					chapters: [
						{
							title: "",
							text: "medical consultation by telephone in case of sudden urgency while travelling.",
							limit: null
						}
					]
				},
				{
					title: "INDICATION OF SPECIALIST DOCTOR",
					chapters: [
						{
							title: "",
							text: "If following the Medical Consultation by Telephone, the Insured Party is to undergo a specialist visit, the Operations Center shall indicate, consistent with local availability, the name of a specialist doctor in the location closest to the Insured Party.",
							limit: null
						}
					]
				},
				{
					title: "MEDICAL TRANSFER",
					chapters: [
						{
							title: "MEDICAL TRANSFER",
							text: "Should the medical service of the Operations Center recommend the medical transfer of the Insured Party, subject to the analysis of the clinical picture and in agreement with the attending physician on location, the Operations Center shall organize: The medical transfer of the Insured Party to the closest adequate Health Facility.",
							limit: null
						},
						{
							title: "FIRST AID",
							text: "In the event of a medical transfer to a health facility or a location equipped with emergency room facilities, the Operations Center shall cover all medical and pharmaceutical costs, with direct payment of the facility and/or reimbursement.",
							limit: "€ 2.500"
						}
					]
				},
				{
					title: "MEDICAL REPATRIATION",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party who has been discharged from the Health Facility in which they were hospitalized require a period of Hospitalization exceeding 7 days, in the judgment of the doctors of the Operations Centers and in agreement with the attending physician on location, or need to return to a qualified Health Facility in the country of Residence or Domicile as chosen by the Insured Party, consistent with the medical evaluations of the Operations Center, the Operations Center shall act, at the expense of the Company, to organize the return trip with the means and times considered most appropriate, at its sole discretion.",
							limit: null
						}
					]
				},
				{
					title: "URGENT DELIVERY OF MEDICINE",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party require medicines that are duly registered in the country of Residence but not available in the travel location, nor can they be substituted with other local medicines considered equivalent by the medical service of the Operations Center, the Operations Center shall send those medicines by the most rapid means possible while respecting the regulations and times governing the transport of medicines.",
							limit: "The Company will bear the cost of shipping, while the cost of the medicines remains the responsibility of the Insured."
						}
					]
				},
				{
					title: "INTERPRETER",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party who is on a Trip be hospitalized and have language difficulties in communicating with the doctors, the Operations Center shall send an interpreter to the location.",
							limit: "Costs of the interpreter up to a maximum of 8 working hours."
						}
					]
				},
				{
					title: "TRANSLATION OF MEDICAL RECORD",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party require the translation of their medical record following Hospitalization during a Trip, the Party may request the translation into English, French, German, Spanish and Italian.",
							limit: null
						}
					]
				},
				{
					title: "FAMILY MEMBER TRIP IN CASE OF HOSPITALIZATION",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party be hospitalized, or in the event of death of the Insured Party, the Operations Center shall provide a round trip ticket (first class on train or economy class on airplanes, or another means of transport at its sole discretion) to allow a Family Member (or more than one, up to a maximum of three people), to reach the hospitalized Insured Party or the place of death.",
							limit: "This includes accommodation expenses for the Family member for a maximum of 7 days."
						}
					]
				},
				{
					title: "EXTENSION OF STAY",
					chapters: [
						{
							title: "",
							text: "Should the health conditions of the Insured Party, as certified by a written medical prescription, not allow for making the return Trip to their Residence or Domicile on the anticipated date, the Operations Center shall make a  hotel reservation.",
							limit: "€ 300 per day annual aggregate € 4.500"
						}
					]
				},
				{
					title: "RETURN OF CONVALESCENT INSURED PARTY",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party who has been discharged from the hospital in which they were hospitalized require a period of convalescence exceeding 7 days, in the opinion of the doctors of the Operations Center and in agreement with the attending physician on location, the Operations Center, at the expense of the Company, shall cover the return of the Insured Party to their Residence or Domicile, at the Insured Party’s discretion, consistent with the medical evaluation of the Operations Center and with the means and times considered most appropriate by the doctors of the Operations Center upon consultation with the attending physician on location.",
							limit: "The Insurance Company will bear the hotel expenses (room and breakfast). Hotel expenses other than room and breakfast for € 300 per day with an annual limit of € 4.500"
						}
					]
				},
				{
					title: "RETURN OF COLLEAGUES TOGETHER WITH CONVALESCENT INSURED PARTY",
					chapters: [
						{
							title: "",
							text: "In the case of return of a convalescent Insured Party, the Guarantee is also extended to a Travel companion/colleague.",
							limit: "€ 2.000"
						}
					]
				},
				{
					title: "RETURN OF CORPSE",
					chapters: [
						{
							title: "",
							text: "The Operations Center shall organize and carry out the transport of the corpse to the place of burial, that may be the Residence or Domicile, at the family members’ discretion. The transport shall be carried out following international regulations on the subject and after having fulfilled all of the formalities in the place of death.",
							limit: "Limited to € 5.000 for funeral services"
						}
					]
				},
				{
					title: "EARLT RETURN",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party on a Trip need to return to their Residence or Domicile, before the scheduled date and with means different than those initially planned, due to the death of one of the following Family Members: spouse/partner, child, brother, sister, parent, mother/father-in-law, or son/daughter-in-law, the Operations Center shall organize the return of the Insured Party.",
							limit: "The Company will bear the relative cost (round trip ticket)."
						}
					]
				},
				{
					title: "TRAVEL OF A SUBSTITUTE COLLEAGUE",
					chapters: [
						{
							title: "",
							text: "Should the health conditions of the Insured Party, certified by a written medical prescription, make it necessary to substitute the Insured Party with a colleague, the Operations Center shall provide, at the Company’s expense, a round trip train ticket (first class) or a one-way airplane ticket (economy class), and potentially the return ticket, to allow a colleague to substitute the Insured Party.",
							limit: "the Company will bear the cost of the one-way train ticket (first class) or one-way air ticket (economy class) and possibly return, to allow a colleague to replace the Insured in his or her role."
						}
					]
				},
				{
					title: "ADVANCE OF ESSENTIAL EXPENSES IN THE EVENT OF THEFT, ROBBERY OR LOSS OF MEANS OF PAYMENT",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party have to sustain unanticipated essential expenses during the Trip, but be unable to do so directly and immediately due to theft, robbery or loss of their means of payment, the Operations Center may advance the amounts indicated by the corresponding documentation (invoice) with direct payment.",
							limit: "maximum advance of € 15.000<br/>(to be returned within 30 days after payment)"
						}
					]
				},
				{
					title: "ADVANCE OF LEGAL AID EXPENSES",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party be arrested or threatened with arrest and require Legal Aid, the Operations Center shall make a lawyer available to the Insured Party, in accordance with local regulations, and shall provide an advance for payment of the fees.",
							limit: "maximum advance of € 15.000<br/>(to be returned within 30 days after payment)"
						}
					]
				},
				{
					title: "ADVANCE OF BAIL",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party, during the Trip, be detained, arrested or threatened with arrest and not be able to make direct payment of the bail to be released, the Company may pay the bail within the relevant limit, as an advance on behalf of the Insured Party.",
							limit: "maximum advance of € 15.000<br/>(to be returned within 30 days after payment)"
						}
					]
				},
				{
					title: "SHIPMENT OF PERSONAL BELONGINGS",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party be repatriated, the Company shall organize at its own expense the shipment of the personal belongings that the Insured Party has left at the place of the Claim.",
							limit: null
						}
					]
				},
				{
					title: "RETURN OF THE INSURED PARTY TO THE DESTINATION LOCATION OF THE TRIP",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party’s return ticket have been used for medical repatriation, the Company shall organize and cover the cost (round trip economy airplane ticket or first class train ticket) to allow the Insured Party to return to the initial location of the Business Trip.",
							limit: null
						}
					]
				},
				{
					title: "TELEPHONE CONNECTION WITH HEALTH FACILITY",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party be hospitalized following an Injury or Sudden Illness, the Operations Center may keep the Insured Party’s Family Members informed, by telephone connection between its own medical service and the attending physician in the Hospitalization location. The clinical information shall be communicated by telephone upon request from the Insured Party or a third party, if the Insured Party is unable to do so.",
							limit: null
						}
					]
				},
				{
					title: "EARLY RETURN FOR DAMAGE TO HOME",
					chapters: [
						{
							title: "",
							text: "Should the Insured Party on a Trip need to return immediately to their home that has been damaged following theft, attempted theft, fire, explosion, bursting or flooding that has caused serious damage to at least 50% of the home, requiring the Party’s presence, the Operations Center shall provide a travel ticket to return to the Residence or Domicile, at the discretion of the Insured Party.",
							limit: null
						}
					]
				},
				{
					title: "SEARCH AND RESCUE COSTS",
					chapters: [
						{
							title: "",
							text: "The Company shall reimburse the costs for search and rescue at sea, on land, in the mountains and forests, for which the competent authorities request payment from the Insured Party.",
							limit: "€ 30.000 per claim"
						}
					]
				},
				{
					title: "EVACUATION FOR POLITICAL REASONS OR EPIDEMIC",
					chapters: [
						{
							title: "",
							text: "The Company shall reimburse the evacuation costs sustained by the Insured Party, in only the following cases:<ul><li>when the Insured Party has been expelled or declared persona non grata by the official government authorities of the state in which the Party resides,</li><li>transfer of the Insured Party to a secure location outside of the location of the Insured Party’s trip,</li><li>political or military events in the state in which the Insured Party is located,</li><li>natural disaster in the area where the Insured Party is located,</li><li>nuclear catastrophe within a range of 100 km of the place of the Insured Party’s abode,</li><li>epidemic or pandemic declared by the World Health Organization, when that situation is within a range of 100 km of the Insured Party’s place of abode;</li><li>bankruptcy or insolvency of the travel services by the organizer of the trip/airline</li></ul>",
							limit: "€ 50.000 per claim"
						}
					]
				},
				{
					title: "PERSONAL BELONGINGS OF THE INSURED PARTY",
					chapters: [
						{
							title: "",
							text: "Following evacuation of the Insured Party for political reasons, pandemic or epidemic, the Company shall Compensate the Insured Party for the personal belongings that it was not possible to bring and that remained in the location.",
							limit: "€ 2.000 per claim"
						}
					]
				},
			]
		}
	}
}
</script>
